import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Select from '@components/select/Select'

const TextInputsSection = () => {
  return (
    <Section>
      <SectionTitle>Selects</SectionTitle>
      <Container>
        <Select label="Select" onClick={() => null} />
      </Container>
      <Container>
        <Select label="with Camera icon" onClick={() => null} icon="photo" />
      </Container>
      <Container>
        <Select label="Select icon on left" onClick={() => null} left icon="photo" />
      </Container>
      <Container>
        <Select label="Select click disabled" onClick={() => null} disabled />
      </Container>
      <Container>
        <Select label="Select empty style" onClick={() => null} selectStyle="empty" />
      </Container>
      <Container>
        <Select label="Select bold style" onClick={() => null} selectStyle="bold" />
      </Container>
    </Section>
  )
}

export default TextInputsSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const Container = styled(View)`
  margin-bottom: 12px;
`
